import { Vue, Component, Prop } from 'vue-property-decorator';
import { CreateElement, VNodeData } from 'vue';

@Component
export default class ClCollapse extends Vue {
  @Prop({
    type: String,
    default: '0px'
  })
  public collapsedHeight!: string; /* TODO */

  @Prop({
    type: String,
    default: 'div'
  })
  public component!: string;

  handleAfterEnter(element: HTMLElement) {
    if (!this.open) {
      return;
    }
    element.style.height = 'auto';
    this.$emit('after-enter', element);
  }

  handleEnter(element: HTMLElement): void {
    if (!this.open) {
      return;
    }
    this.$emit('enter', element);
    const width = getComputedStyle(element).width;
    element.style.width = width;
    element.style.position = 'absolute';
    element.style.visibility = 'hidden';
    element.style.height = 'auto';
    const height = getComputedStyle(element).height;
    element.style.width = null;
    element.style.position = null;
    element.style.visibility = null;
    element.style.height = this.collapsedHeight;
    setTimeout(() => {
      element.style.height = height;
    });
  }

  handleLeave(element: HTMLElement) {
    if (this.open) {
      return;
    }
    const height = getComputedStyle(element).height;
    element.style.height = height;
    setTimeout(() => {
      element.style.height = this.collapsedHeight;
    });
  }

  @Prop({
    type: Boolean,
    default: false
  })
  public open!: boolean;

  public style!: object;

  render(h: CreateElement) {
    const transitionData: VNodeData = {
      props: {
        name: 'cl-collapse'
      },
      on: {
        afterEnter: this.handleAfterEnter,
        enter: this.handleEnter,
        leave: this.handleLeave
      }
    };
    const openComponentData: VNodeData = {
      key: 'open',
      class: {
        'cl-collapse': true,
        'cl-collapse--open': true
      },
      style: this.style
    };
    const closedComponentData: VNodeData = {
      key: 'closed',
      class: {
        'cl-collapse': true
      },
      style: {
        ...this.style,
        height: this.collapsedHeight
      }
    };
    const wrapperData: VNodeData = {
      class: 'cl-collapse__wrapper'
    };
    const wrapperInnerData: VNodeData = {
      class: 'cl-collapse__wrapper-inner'
    };
    const content = h('div', wrapperData, [
      h('div', wrapperInnerData, this.$slots.default)
    ]);
    const openComponent = h(this.component, openComponentData, [content]);
    const closedComponent = h(this.component, closedComponentData, [content]);
    return h('transition', transitionData, [
      this.open ? openComponent : closedComponent
    ]);
  }
}
